<template>
  <div class="worldcuprule">
    <header>
      <b>{{$t('300140')}}</b>
    </header>
    <main v-html="config.content"></main>
  </div>
</template>

<script>
import {
  worldcupconfig //活动配置
} from "../api/resource";
export default {
  data() {
    return {
      config: {}
    };
  },
  created() {
    this.worldcupconfig();
  },
  methods: {
    worldcupconfig() {
      worldcupconfig().then(res => {
        this.config = res.data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/variableName";
@import "../style/mixin";
.worldcuprule {
  height: 100vh;
  width: 100vw;
  overflow-y: scroll;
  padding: torem(24) torem(20);
  box-sizing: border-box;
  background: #fff;
  header {
    b {
      font-size: torem(24);
      color: #333333;
    }
  }
  main {
    margin-top: torem(32);
    line-height: normal;
    font-size: torem(16);
  }
}
</style>


// WEBPACK FOOTER //
// src/view/worldcuprule.vue